import AxiosHealthWellness from '../../../services/healthWellness';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const SKIP_LIFF = process.env.REACT_APP_SKIP_LIFF === 'true';

// Use dev axios instance when LIFF is skipped (localhost dev)
const devAxios = axios.create({ timeout: 30000 });
devAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('devToken');
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }
  const customer = JSON.parse(sessionStorage.getItem('customer'));
  if (customer) {
    config.headers.account = customer.amwayNumber || '';
    config.headers.customer = customer.partyId || '';
  }
  return config;
});

const http = SKIP_LIFF ? devAxios : AxiosHealthWellness;

/**
 * Fetch begin challenge assessment questions
 * GET /hwAssessment/hwassessmentQuestion
 * @param {string} assessmentId
 * @returns {{ hw_assessments_questions: Array, metaData: Object }}
 */
export const fetchBeginChallengeQuestions = async (assessmentId) => {
  const customer = JSON.parse(sessionStorage.getItem('customer'));
  const customerId = customer?._id || '';
  const response = await http.get(
    `${API_URL}/hwAssessment/hwassessmentQuestion`,
    {
      params: {
        assessment_id: assessmentId,
        customer_id: customerId,
        assessmentsStatus: 'PENDING',
      },
    },
  );
  return response?.data?.data;
};

/**
 * Submit begin challenge assessment answers
 * POST /hwAssessment/hwAnswer
 * @param {{ assessmentId: string, answers: Array<{ questionId: string, answerId: string, score: number }> }}
 * @returns {{ success: boolean, answerId: string }}
 */
export const submitBeginChallengeAnswers = async ({ assessmentId, answers }) => {
  const customer = JSON.parse(sessionStorage.getItem('customer'));
  const customerId = customer?._id || '';

  const totalScore = answers.reduce((sum, a) => sum + (a.score || 0), 0);

  const response = await http.post(
    `${API_URL}/hwAssessment/hwAnswer`,
    {
      customer_id: customerId,
      assessment_id: assessmentId,
      answer_id: '',
      assessmentsStatus: 'DONE',
      score: totalScore,
      weight: 0,
      height: 0,
      waist: 0,
      bmi: 0,
      answers: answers.map((a) => ({
        question_id: a.questionId,
        answer: [a.answerId],
      })),
    },
  );
  return response?.data;
};
